import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IconChevronRight } from '@tabler/icons-react';
import '../css/Breadcrumbs.css';
import { usePreference } from '../context/PreferenceContext';

const breadcrumbNameMap = {
    '/buyer': 'buyer',
    '/buyer/dashboard': 'dashboard',
    '/buyer/orders': 'orders',
    '/buyer/profile': 'profile',
    '/buyer/addresses': 'addresses',
    '/buyer/cancellation-requests': 'cancellations',
    '/buyer/return-requests': 'returns',
    '/buyer/rewards': 'rewards',
    '/buyer/rewards/points': 'points',
    '/buyer/rewards/share': 'share_earn',
    '/buyer/rewards/offers': 'offers',
    '/buyer/security': 'security',
    '/buyer/notifications': 'notifications',
    '/buyer/wishlist': 'wishlist',
    '/buyer/rewards/credits': 'my_credits',
    '/buyer/contact': 'support',

    '/admin': 'admin',
    '/admin/dashboard': 'dashboard',
    '/admin/products-catalog': 'products',
    '/admin/categories': 'categories',
    '/admin/brands': 'brands',
    '/admin/seller-investors': 'seller_investors',
    '/admin/seller-requests': 'seller_requests',
    '/admin/product-options': 'product_options',
    '/admin/product-tags': 'product_tags',
    '/admin/shop': 'shop',
    '/admin/user': 'users',
    '/admin/product-feedback': 'product_feedback',
    '/admin/product-inventory-thresholds': 'inventory_thresholds',
    '/admin/returns': 'returns',
    '/admin/coupons': 'coupons',
    '/admin/language': 'language',
    '/admin/currency': 'currency',
    '/admin/admin-permissions': 'admin_permissions',
    '/admin/notifications': 'notifications',

    '/seller': 'seller',
    '/seller/dashboard': 'dashboard',
    '/seller/orders': 'orders',
    '/seller/profile': 'profile',
    '/seller/shop-setup': 'shop_setup',
    '/seller/product-setup': 'product_setup',
    '/seller/shop-settings': 'shop_settings',
    '/seller/product-option': 'product_options',
    '/seller/product-sold': 'products_sold',
    '/seller/inventory-update': 'inventory_update',
    '/seller/cod-instructions': 'cod_instructions',
    '/seller/delivery-address': 'delivery_address',
    '/seller/deliveries': 'deliveries',
    '/seller/delivery-settings': 'delivery_settings',
    '/seller/delivery-staff': 'delivery_staff',
    '/seller/delivery-staff-fee': 'delivery_staff_fee',
    '/seller/sales': 'sales',
    '/seller/sales/invoices': 'invoices',
    '/seller/import': 'import_data',
    '/seller/export': 'export_data',
    '/seller/reports': 'reports',
    '/seller/reports/sales': 'sales_reports',
    '/seller/reports/products': 'product_reports',
    '/seller/returns': 'returns',
    '/seller/notifications': 'notifications',
};

// Breadcrumbs hidden — returns null
const Breadcrumbs = () => null;

export { breadcrumbNameMap };
export default Breadcrumbs;
